import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { HomePage } from '../../translations/trans';
import { urlBase } from '../../utils/API';
const ViewHW = ({ session, studentId }) => {
    const [showTable, setShowTable] = useState(false);
    const [studentHomework, setStudentHomework] = useState([]);


    const handleCloseTable = () => setShowTable(false);
    const handleShowTable = () => {
        setShowTable(true)
    }
    const { lang, dir } = useSelector(({ language }) => {
        return { lang: language.lang, dir: language.dir };
    });

    // console.log(session)
    const checkHomeWork = () => {
        if (session?.homeWork) {
            const filteredHomework = session.homeWork
                .filter((homework) => {
                    const homeworkStudentId = homework?.student?._id || homework?.student;
                    return homeworkStudentId?.toString() === studentId?.toString();
                })
                .sort((first, second) => (first.index || 0) - (second.index || 0));
            setStudentHomework(filteredHomework);
        }
    };

    useEffect(() => {
        checkHomeWork();
    }, [session, studentId]);

    // console.log(studentHomework)
    return (

        <div>
            <button className='btn' onClick={handleShowTable} style={{ backgroundColor: "#4169E2" }}>
                {HomePage.viewHW[lang]}
            </button>
            <Modal show={showTable} onHide={handleCloseTable} centered size='xl' dir={dir}>
                <Modal.Body >
                    <div className="pdf-container">
                        {studentHomework.map((homework, index) => (
                            <div className="mt-3" key={homework?._id || homework?.file}>
                                <p>
                                    {lang === 'AR' ? 'الملف' : 'File'} {homework?.index || index + 1} / {studentHomework.length}
                                </p>
                                <object className="pdf-object" data={`${urlBase}/${homework?.file}`} type="application/pdf" width="100%" height="500px">
                                    <embed src={`${urlBase}/${homework?.file}`} type="application/pdf" />
                                </object>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ViewHW
